import { useEffect, useRef } from 'react';

/**
 * Adds a 'visible' class to the ref'd element when it enters the viewport.
 * If stagger=true, looks for children with [data-reveal] and reveals them
 * one by one with a 150ms delay between each.
 */
function useScrollReveal(stagger = false) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;

        if (stagger) {
          const targets = el.querySelectorAll('[data-reveal]');
          targets.forEach((target, i) => {
            setTimeout(() => target.classList.add('visible'), i * 150);
          });
        } else {
          el.classList.add('visible');
        }

        observer.unobserve(el);
      },
      { threshold: 0.12 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [stagger]);

  return ref;
}

export default useScrollReveal;
